import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "bill-header" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "amount-info" }
const _hoisted_5 = { class: "income" }
const _hoisted_6 = { class: "money" }
const _hoisted_7 = { class: "expense" }
const _hoisted_8 = { class: "money" }
const _hoisted_9 = { class: "bill-list" }
const _hoisted_10 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_11 = { class: "left" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "time" }

import { ref, onMounted } from 'vue'
import CustomTitleBar from "@/components/CustomTitleBar/index.vue"
import { showToast } from 'vant'
import { getBillList } from '@/api/wallet'

interface BillItem {
  title: string
  amount: number
  type: number
  timestamp: number
}
// 分页参数
interface DatePickerValue {
  selectedValues: [string, string]
}

// 修改日期选择处理函数

export default /*@__PURE__*/_defineComponent({
  __name: 'billingRecord',
  setup(__props) {

const current = ref(1)
const size = ref(10)
const start = ref<number>(0)
const end = ref<number>(0)

// 列表相关
const loading = ref(false)
const finished = ref(false)
const billList = ref<BillItem[]>([])

// 统计数据
const currentMonth = ref('')
const totalIncome = ref(0)
const totalExpense = ref(0)

// 添加日期选择相关变量
const showCalendar = ref(false)
const currentDate = ref<string[]>([
  String(new Date().getFullYear()),
  String(new Date().getMonth() + 1).padStart(2, '0')
])

// 添加初始化月份的函数
const initCurrentMonth = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  currentMonth.value = `${year}年${month}月`

  // 设置月初时间戳
  const startDate = new Date(year, month - 1, 1)
  start.value = startDate.getTime()

  // 设置月末时间戳
  const endDate = new Date(year, month, 0, 23, 59, 59)
  end.value = endDate.getTime()
}

// 修改日期选择器相关的类型定义和处理
const onMonthSelect = (value: DatePickerValue) => {
  const [year, month] = value.selectedValues
  currentMonth.value = `${year}年${month}月`
  showCalendar.value = false

  // 设置月初时间戳
  const startDate = new Date(Number(year), Number(month) - 1, 1)
  start.value = startDate.getTime()

  // 设置月末时间戳
  const endDate = new Date(Number(year), Number(month), 0, 23, 59, 59)
  end.value = endDate.getTime()

  // 重置列表数据和状态
  current.value = 1
  billList.value = []
  finished.value = false
  loading.value = false

  // 手动触发数据加载
  onLoad()
}


const onLoad = () => {
  loading.value = true

  getBillList({
    current: current.value,
    size: size.value,
    start: start.value,
    end: end.value
  }).then((res) => {
    if (res.code === 200) {
      const { income, expenditure, pageUtils } = res.data

      // 更新总收支
      totalIncome.value = income || 0
      totalExpense.value = expenditure || 0

      // 检查是否有数据
      if (!pageUtils.list || pageUtils.list.length === 0) {
        finished.value = true
        loading.value = false
        return
      }

      // 处理列表数据
      const formattedList = pageUtils.list.map((item: BillItem) => ({
        ...item,
        time: formatTime(item.timestamp)
      }))

      billList.value.push(...formattedList)

      // 判断是否加载完成
      if (pageUtils.currPage >= pageUtils.totalPage) {
        finished.value = true
      }

      current.value = pageUtils.currPage + 1
    } else {
      showToast('获取账单列表失败')
      finished.value = true
    }
    loading.value = false
  }).catch((error) => {
    console.error('获取账单列表失败:', error)
    showToast(`获取账单列表失败: ${error.message || '未知错误'}`)
    loading.value = false
    finished.value = true
  })
}

const formatTime = (timestamp: number) => {
  const date = new Date(timestamp);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');

  return `${month}/${day} ${hour}:${minute}`;
}

onMounted(() => {
  // 初始化当前月份
  initCurrentMonth()
  // 加载数据
  onLoad()
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_date_picker = _resolveComponent("van-date-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "账单" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "month",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCalendar.value = true))
          }, [
            _createTextVNode(_toDisplayString(currentMonth.value) + " ", 1),
            _createVNode(_component_van_icon, { name: "arrow-down" })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _cache[5] || (_cache[5] = _createTextVNode("收入：")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(totalIncome.value) + "鲸油", 1)
            ]),
            _createElementVNode("span", _hoisted_7, [
              _cache[6] || (_cache[6] = _createTextVNode("支出：")),
              _createElementVNode("span", _hoisted_8, _toDisplayString(totalExpense.value) + "鲸油", 1)
            ])
          ])
        ])
      ]),
      _createVNode(_component_van_popup, {
        show: showCalendar.value,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showCalendar).value = $event)),
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_date_picker, {
            modelValue: currentDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentDate).value = $event)),
            title: "选择年月",
            "min-date": new Date(2020, 0),
            "max-date": new Date(),
            "columns-type": ['year', 'month'],
            onConfirm: onMonthSelect,
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (showCalendar.value = false))
          }, null, 8, ["modelValue", "min-date", "max-date"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          onLoad: onLoad,
          "immediate-check": true,
          offset: 10
        }, {
          default: _withCtx(() => [
            (billList.value.length === 0 && finished.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_van_empty, { description: "暂无账单记录" })
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bill-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(formatTime(item.timestamp)), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["amount", { 'income': item.type === 0, 'expense': item.type === 1 }])
                }, _toDisplayString(item.type === 0 ? '+' : '-') + _toDisplayString(item.amount), 3)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ])
    ])
  ], 64))
}
}

})